import { Typography } from '@mui/material'
import { User } from 'hooks/services/users/types'
import { useTranslation } from 'react-i18next'
import { CustomAvatar } from './CustomAvatar'

type Props = {
  user?: User
}

const Author = ({ user }: Props) => {
  const { t } = useTranslation()
  const hasName = Boolean(user?.givenName && user?.familyName)

  let title: string | JSX.Element = ''

  switch (true) {
    case hasName:
      title = (
        <div>
          <Typography variant="body2">{`${user?.givenName} ${user?.familyName}`}</Typography>
          {user?.email && <Typography variant="body2">{user.email}</Typography>}
        </div>
      )
      break
    case Boolean(user?.email):
      title = <Typography variant="body2">{user?.email}</Typography>
      break
    default:
      title = (
        <Typography variant="body2">{t('pages.settings.resources.availabilityConstraints.modal.constraints_history.unknown')}</Typography>
      )
      break
  }

  const src = user?.photoUrl ?? undefined

  return (
    <CustomAvatar src={src} title={title}>
      {!user?.photoUrl && hasName ? user?.givenName.charAt(0) : '?'}
    </CustomAvatar>
  )
}

export { Author }
